export default __webpack_public_path__ + "static/media/follow_the_line_responsive.16718afc.png";